/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
import React, { Fragment, useEffect, useState } from 'react';
import { Row, Collapse, Card, Button, UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, CustomInput } from 'reactstrap';
import {
    Separator,
    Colxx,
} from '../../../../components/common/CustomBootstrap';
import DocumentForm from './Components/DocumentForm';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import { API_Documents, postAPI_Business_Operator_PublishGPT } from '../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import DocumentList from './Components/DocumentList';
import Logs from './Components/Logs';
import Validation from '../../../../components/Validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDotCircle } from '@fortawesome/free-solid-svg-icons';
import no_document from './../../../../assets/no_document.png';
import { NotificationManager } from '../../../../components/common/react-notifications';
import IntlMessages from '../../../../helpers/IntlMessages';
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
    top:auto !important;
    bottom: 0 !important;
  }
  .active{
    background-color:transparent;
  }`;

const sortOptions = [{ 'text': 'Date Newest to Oldest', value: 'Date:DESC', label: 'Date DESC' }, { 'text': 'Date Oldest to Newest', value: 'Date:ASC', label: 'Date ASC' },
{ 'text': 'Title A to Z', value: 'Title:ASC', label: 'Title ASC' }, { 'text': 'Title Z to A', value: 'Title:DESC', label: 'Title DESC' }]


const Documents = ({ match, propertyId, locale, email }) => {
    const [sortType, setSortType] = useState('Title:ASC');
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [createDocument, setCreateDocument] = useState(false);
    const [showLogs, setShowLogs] = useState(false);
    const [tags, setTags] = useState([]);
    const [documentList, setDocumentList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [checkboxes, setCheckboxes] = useState({
        pii: false,
        confidentiality: false,
        harmfulfree: false,
    });
    const [isFormValid, setIsFormValid] = useState(false);
    const handleToggle = () => {
        setCreateDocument(!createDocument);
    }


    useEffect(() => {
        LoadData();
    }, [propertyId, sortType]);

    const LoadData = () => {
        AxiosAPI({
            method: 'get',
            url: `${API_Documents}?groupId=${getGroupID()}&propertyId=${propertyId}&sortType=${sortType}`,
        }).then((res) => {
            if (res.data.length > 0) {
                res.data.map((m) => {
                    if (m.tags !== undefined && m.tags.length > 0) {
                        m.tags.map((t) => {
                            if (tags.filter(m => m == t).length === 0)
                                tags.push(t);
                        })
                    }
                })
            }
            setDocumentList(res.data);
        });
    };


    const handleAddDocument = (inputData) => {
        AxiosAPI({
            method: 'post',
            url: API_Documents,
            data: inputData,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                handleToggle();
                LoadData();
            }
        });
    };

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setCheckboxes((prev) => {
            const updatedCheckboxes = { ...prev, [name]: checked };
            setIsFormValid(updatedCheckboxes.pii && updatedCheckboxes.confidentiality && updatedCheckboxes.harmfulfree);
            return updatedCheckboxes;
        });
    };
    const handlePublish = () => {
        var body = {
            GroupId: getGroupID(),
            PropertyId: propertyId,
            Language: locale === 'en' ? 'en-US' : locale,
            email: email,
            version: 3,
            type: 1,
            Creator: 'dashboard',
        };
        AxiosAPI({
            method: 'post',
            url: `${postAPI_Business_Operator_PublishGPT}`,
            data: body,
        }).then(() =>
            NotificationManager.success(
                '',
                'We have received your request. Publish will take few minutes.',
                3000,
                null,
                null,
                'success'
            )
        );
        toggleModal();
    };

    const handleShowLogs = () => {
        setShowLogs(!showLogs);
    }
    return (
        <Fragment>
            <div className="mb-4">
                <h4><b><IntlMessages id="dashboards.trainAI" /></b></h4>
                <p>  <IntlMessages id="dashboards.uploadDocuments" /></p>
            </div>

            <Row>
                <Colxx xxs="12" className="mb-0">
                    <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                        <DropdownToggle caret color="outline-dark" size="xs">
                            <IntlMessages id='dashboards.order-by' />
                            {sortOptions.filter(f => f.value === sortType).length > 0 ? ": " + sortOptions.filter(f => f.value === sortType)[0].label : ""}
                        </DropdownToggle>
                        <DropdownMenu>
                            {sortOptions.map((order, index) => {
                                return (
                                    <DropdownItem
                                        key={index}
                                        onClick={() => setSortType(order.value)}
                                    >
                                        {order.text}
                                    </DropdownItem>
                                );
                            })}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    <Button size="xs" outline className='' onClick={handleToggle} color='primary'> + <IntlMessages id='dashboards.adddocument' /></Button >
                    <Button size="xs" outline className='ml-2' color='primary' onClick={handleShowLogs}><IntlMessages id='dashboards.changelog' /></Button >
                    {/* <Button size="xs" outline className='ml-2' color='primary' onClick={toggleModal}>Publish GPT</Button > */}
                    {locale && locale === 'en' && <a href="/app/pages/propinfo/publish-ai">
                        <Button
                            color="primary"
                            outline
                            className='ml-2'
                            size="xs"
                        >
                            Publish AI
                        </Button>
                    </a>
                    }
                </Colxx>
                <Colxx xxs="12" className="mb-2 text-right">
                    <strong><hr /></strong>
                </Colxx>
            </Row>
            <Row className='mb-3'>
                {documentList !== undefined && documentList.length > 0 ?
                    <Colxx xxs="12" className="mb-4">

                        <DocumentList tags={tags} LoadData={LoadData} documentList={documentList}></DocumentList>
                    </Colxx>
                    : <Colxx xxs="12" className="mb-4 text-center"><img className='w-25' style={{ marginTop: '5rem' }} src={no_document}></img></Colxx>
                }
            </Row>
            {createDocument &&
                <DocumentForm taglist={tags} label={"Upload Document"} LoadData={LoadData} toggle={handleToggle} submit={handleAddDocument} visible={createDocument} ></DocumentForm>}

            {showLogs &&
                <Logs label={"Document Logs"} toggle={handleShowLogs} visible={showLogs} logType="Document" ></Logs>}

            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>

        </Fragment >
    );
};

const mapStateToProps = ({ settings }) => {
    const { propertyId, locale, email } = settings;
    return {
        propertyId,
        locale,
        email
    };
};

export default injectIntl(connect(mapStateToProps, {})(Documents));
